import { ApiPaths } from 'services/api/apiPaths';
import { createResourceApi } from '../../createResourceApi';

export const csrfApi = createResourceApi(ApiPaths.CSRF, (rest) => ({
  getAll: () => rest.get<CSRFToken>()
}));
